import { useTranslation } from 'react-i18next';
import './ConsultationTile.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getImageSrc, getRetinaImgSrc } from '../../core/helpers';
import { useBookMeetingModal } from '../../context/bookMeetingModalContext';
import Button from '../Button';

interface Props {
  text?: string;
  className?: string;
}

export default function ConsultationTile({
  text = 'Book a free consultation with our manager to discuss all the questions you have and get advices',
  className = '',
}: Props) {
  const { t } = useTranslation();
  const { openModal } = useBookMeetingModal();

  return (
    <div className={`ConsultationTile text-white ${className}`}>
      <div className='ConsultationTile__text mb-3'>{t(text)}</div>
      <div className='d-flex align-items-center'>
        <Button
          onClick={openModal}
          className='me-3 ConsultationTile__btn'
          styling='dark'
        >
          {t('Book free consultation')}
        </Button>
        <LazyLoadImage
          src={getImageSrc('/images/daniel.png')}
          srcSet={getRetinaImgSrc('/images/daniel-2x.png')}
          alt='Daniel'
          wrapperClassName='d-flex align-items-center justify-content-center'
          className='ConsultationTile__managerImg'
        />
      </div>
    </div>
  );
}
